<script setup>
import { RouterView } from 'vue-router';
</script>
 
<template>
  <div id="app">
    <RouterView />
  </div>
</template>
<style>
body{
  overflow: hidden;
}
</style>
 
 